import { EFormColumn } from './e-form-column.model';
import { EFormRow } from './e-form-row.model';

export class EFormPage {
    Id: number;
    Name: string;
    Order: number;
    Columns: EFormColumn[];
    Rows: EFormRow[];
    ParentObjectId: number;
    Condition: string | boolean;
    Visible: boolean;

    // Tree View Property
    Expanded: boolean;
}